<template>
  <v-card>
    <v-card-title class="text-h6">
      {{ $t("Chi tiết") }}
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="close">
        {{ $t("Đóng") }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <OrderDetail
        :order="order"
        :is-show-item="isShowItem"
        :is-show-exchange="isShowExchange"
        :is-show-card-payment="isShowCardPayment"
        @onOrderChanged="onOrderChanged"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { api as viewerApi } from "v-viewer";
import { IDENTIFICATION_DOCUMENT_NAME } from "@/libs/const";

export default {
  name: "DetailDialog",
  components: {
    OrderDetail: () => import("@/components/common/OrderDetail"),
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    isShowItem: {
      type: Boolean,
      default: () => true,
    },
    isShowExchange: {
      type: Boolean,
      default: () => false,
    },
    isShowCardPayment: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    documentName: { ...IDENTIFICATION_DOCUMENT_NAME },
  }),
  methods: {
    onOrderChanged() {
      this.$emit("onOrderChanged", true);
    },
    close() {
      this.$emit("close", true);
    },

    showContractImages() {
      const images = this.order.contract_image.split(";");
      const imageUrls = images.map(
        (img) => `${process.env.VUE_APP_FILE_CDN_URL}/${img}`
      );
      const index = 0;
      viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: index,
        },
        images: imageUrls,
      });
    },
    showDocumentImages() {
      if (!this.order.identification_document_image) {
        return false;
      }
      const images = this.order.identification_document_image.split(";");
      const imageUrls = images.map(
        (img) => `${process.env.VUE_APP_FILE_CDN_URL}/${img}`
      );
      const index = 0;
      viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: index,
        },
        images: imageUrls,
      });
    },
  },
};
</script>
